export enum CodebookType {
    Unknown = 0,
    Intervention,
    ProfessionalArea,
    ProductionType
}
